import moment from 'moment';

export const getVesselFillOpacity = (t?: string, isHistoryOrPlaybackMode?: boolean) => {
  const maxDifference = 3;
  const minDate = moment.utc().subtract(maxDifference - 1, 'day');
  const isDormant = moment(t).isBefore(minDate);
  const opacity = isDormant && !isHistoryOrPlaybackMode ? '0.6' : '1';
  return opacity;
};
